<template>
  <div>
    <vxe-grid
      ref="skuTable"
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 23"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="toolbar"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('menu_text_setFba') || '回填FBA'"
          placement="right"
        >
          <i class="el-icon-edit tool-btn" @click="$emit('set-scm-fba', row)" />
        </el-tooltip>
      </template>
      <template v-slot:defaultImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displaySku="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel
          label="SIZE"
          labelKey="table_label_goodsSize"
          :value="row.goodsSize"
        />
        <TableLabel
          label="分类"
          labelKey="table_label_masterCategoryName"
          :value="row.masterCategoryName"
        />
        <TableLabel
          label="SKU"
          labelKey="table_label_amzSkuNo"
          primary
          :value="row.amzSkuNo"
        />
        <div class="d-flex justify-content-between align-items-center">
          <div class="flex-1">
            <TableLabel
              v-if="isVc === 'Y'"
              label="VC PO"
              labelKey="table_label_vcPo"
              :value="row.vcPo"
              primary
            />
          </div>
          <div>
            <el-tag
              v-if="row.skuSalesChannel === 'V'"
              size="mini"
              type="warning"
            >
              {{ row.v_skuSalesChannel }}
            </el-tag>
          </div>
        </div>
      </template>
      <template v-slot:displayStore="{ row }">
        <TableLabel
          label="店铺"
          labelKey="table_label_invStoreName"
          :value="row.invStoreName"
        />
        <TableLabel
          label="Store SKU"
          labelKey="table_label_amzSkuStoreNo"
          :value="row.amzSkuStoreNo"
          primary
        />
        <TableLabel
          label="ASIN"
          labelKey="table_label_asinCode"
          :value="row.asinCode"
          primary
        />
        <TableLabel
          label="FNSKU"
          labelKey="table_label_fnskuCode"
          :value="row.fnskuCode"
          primary
        />
        <TableLabel
          label="UPC"
          labelKey="table_label_upc"
          :value="row.upc"
          primary
        />
        <TableLabel
          label="运营"
          labelKey="table_label_operateName"
          :value="row.operateName"
        />
        <el-tag
          v-if="row.v_storeSkuStatus"
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus }}
        </el-tag>
      </template>
      <template v-slot:displaySubmitQty="{ row }">
        <TableLabel
          label="补货数量"
          labelKey="table_label_submitQty"
          :value="row.submitQty || '0'"
          primary
        />
        <TableLabel
          label="装箱入数"
          labelKey="table_label_unitInBox"
          :value="row.unitInBox"
        />
        <TableLabel
          label="补货箱数"
          labelKey="table_label_ctnQty"
          :value="row.submitQty / row.unitInBox"
          primary
        />
      </template>
      <template v-slot:displayOperate="{ row }">
        <TableLabel
          label="预计上架日期"
          labelKey="table_label_etaDate"
          :value="row.etaDate"
        />
        <TableLabel
          label="中途断货天数"
          labelKey="table_label_halfwayOutageDays"
          :value="row.halfwayOutageDays || '0'"
        />
        <TableLabel
          label="实际日销售量"
          labelKey="table_label_advQtyBeforeRepPerDay"
          :value="row.advQtyBeforeRepPerDay || '0'"
        />
        <TableLabel
          label="到货日预估日销"
          labelKey="table_label_soldQtyAfterRepPerDay"
          :value="row.soldQtyAfterRepPerDay || '0'"
        />
        <TableLabel
          label="到货日活动销量"
          labelKey="table_label_advQtyAfterRepPerDay"
          :value="row.advQtyAfterRepPerDay || '0'"
        />
      </template>
      <template v-slot:displayFba="{ row }">
        <TableLabel
          label="出货工厂"
          labelKey="table_label_displayScmName"
          :value="row.scmName"
        />
        <TableLabel
          label="配送中心"
          labelKey="table_label_fbaDc"
          :value="row.fbaDc"
        />
        <TableLabel
          label="货件编号"
          labelKey="table_label_fbaId"
          :value="row.fbaId"
        />
        <TableLabel
          label="货件追踪编号"
          labelKey="table_label_fbaIdReferenceId"
          :value="row.fbaIdReferenceId"
        />
        <el-tag
          size="mini"
          effect="dark"
          class="mr-1"
          :type="
            row.restockStatus === 'O'
              ? 'danger'
              : row.restockStatus === 'P'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_restockStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
  },
  watch: {
    isVc() {
      this.$refs.skuTable.refreshColumn()
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.skuTable.clearCheckboxRow()
      this.$refs.skuTable.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImage']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.skuTable
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
